<script setup>
import { isCurrentUserAuthenticated, isCurrentUserRoleIsAdmin } from "@/lib/auth";
import { onMounted, ref } from "vue";
import { RouterLink } from "vue-router";

const isAuthenticated = ref(false);
const isAdmin = ref(false);

// Update auth status when component mounts
onMounted(async () => {
    try {
        isAuthenticated.value = await isCurrentUserAuthenticated();
        isAdmin.value = await isCurrentUserRoleIsAdmin();
    } catch (error) {
        console.error("Error checking authentication status:", error);
    }
});
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <!-- Header -->
    <header class="bg-white shadow-sm">
      <div class="max-w-7xl mx-auto flex justify-between items-center">
        <div class="flex items-center">
          <RouterLink to="/" class="flex items-center space-x-2">
            <img src="@/assets/logo_full.svg" class="w-64" alt="Logo" />
          </RouterLink>
        </div>
        <nav>
          <RouterLink v-if="!isAuthenticated" to="/login" class="text-blue-600 hover:text-blue-800 px-3 py-2">
            Sign In
          </RouterLink>
          <RouterLink v-else-if="isAdmin" to="/admin" class="text-blue-600 hover:text-blue-800 px-3 py-2">
            Admin Panel
          </RouterLink>
        </nav>
      </div>
    </header>

    <!-- Page Content -->
    <main class="flex-grow">
      <div class="max-w-7xl mx-auto px-4 py-6">
        <RouterView />
      </div>
    </main>

    <!-- Footer -->
    <footer class="bg-gray-100 py-4">
      <div class="max-w-7xl mx-auto px-4 text-center text-gray-500 text-sm">
        &copy; {{ new Date().getFullYear() }} Hart Centre. All rights reserved.
      </div>
    </footer>
  </div>
</template>
